var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.phones),function(phone,index){return [(phone.contact)?_c('div',{key:index,staticClass:"mr-3"},[_c('b',{domProps:{"textContent":_vm._s(_vm.markers[phone.marker])}}),_vm._v(" "+_vm._s(phone.contact)+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }